import { createFeatureSelector, createSelector } from '@ngrx/store';

import { GOOGLE_ANALYTICS_FEATURE_KEY, GoogleAnalyticsState } from './google-analytics.reducer';

// Lookup the 'GoogleAnalytics' feature state managed by NgRx
export const getGoogleAnalyticsState = createFeatureSelector<GoogleAnalyticsState>(GOOGLE_ANALYTICS_FEATURE_KEY);

export const getInitializationStatus = createSelector(
  getGoogleAnalyticsState,
  (state: GoogleAnalyticsState) => state.initialized
);
export const getConfiguration = createSelector(
  getGoogleAnalyticsState,
  (state: GoogleAnalyticsState) => state.configuration
);
export const getLatestPageView = createSelector(
  getGoogleAnalyticsState,
  (state: GoogleAnalyticsState) => state.latestPageView
);
export const getPreviousUrl = createSelector(
  getGoogleAnalyticsState,
  (state: GoogleAnalyticsState) => state.previousUrl
);
